import { useState, useEffect } from 'react';

import { useGetResultsQuery } from '../../common/apis/AdminApi';
import { NoteStatusFilterOption } from '../constants/FilterOptions';
import MenuOption from '../types/MenuOption';

const useFilteredResults = (
  limit: number,
  statusFilters: MenuOption<NoteStatusFilterOption>[],
  sortParams: { sortField?: string; direction?: string },
  searchText?: string
) => {
  const { sortField, direction } = sortParams;
  const [page, setPage] = useState<number>(1);
  const [filterStatuses, setFilterStatuses] = useState<string[]>([]);

  const { data, isFetching: isLoading } = useGetResultsQuery(
    {
      page: page,
      limit,
      search: searchText,
      sortField,
      direction,
      statuses: filterStatuses,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(() => {
    setPage(1);
  }, [searchText]);

  useEffect(() => {
    setFilterStatuses(
      statusFilters
        .filter((filter) => filter.selected)
        .map((filter) => filter.item.toLowerCase())
    );
  }, [statusFilters]);

  return {
    filteredResults: data?.docs ?? [],
    isLoading,
    total: data?.total ?? 0,
    page,
    setPage,
  };
};

export default useFilteredResults;
